import { app } from '../app/app.js';
import { log } from '../app/logger.js';
import { navigation } from '../app/navigation.js';
import { profile } from '../data/profile.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { AccountPanelBase } from './account_panel_base.js';

/**
 * Contact us panel.
 */
class ContactUsPanel extends AccountPanelBase {
  static id = navigation.kContactUsPanelId;

  initialize() {
    super.initialize();

    listenToEvent(this.formElement, 'submit', () => this.contactUs(), {
      blockUI: true,
      preventDefault: true,
    });

    profile.pipe({
      name: v => (this.nameElement.value = v),
      email: v => (this.emailElement.value = v),
    });
  }

  static markup = `
    <div class='spacer'></div>
    <div class='msg' hidden></div>

    <h1>Questions or feedback?</h1>
    <form class='default' autocomplete='never'>
      <input placeholder='Your name' type='text'
             name='name' autocomplete='name'
             required maxlength='254'>
      <input placeholder='Your email' type='email'
             name='email' autocomplete='username'
             required maxlength='254'>
      <input placeholder='Subject' name='subject' required maxlength='254'>
      <textarea placeholder='Please describe your issue here'
                rows='10' name='message' required></textarea>
      <button type='submit'>Text us</button>
    </form>

    <span class='note'>You can also reach us at
      <a class='facebook-link' href='https://www.facebook.com/camperaid/'
         target='_blank' rel='noopener'>
        <svg><use xlink:href='#icon-facebook'></use></svg>
        <span>Facebook</span>
      </a>
    </span>

    <svg hidden>
      <symbol id='icon-facebook' viewBox='0 0 32 32'>
        <title>facebook</title>
        <path d='M1.766 0c-0.976 0-1.766 0.79-1.766 1.766v28.468c0 0.975 0.79 1.766 1.766 1.766h15.326v-12.392h-4.17v-4.829h4.17v-3.562c0-4.133 2.524-6.384 6.211-6.384 1.766 0 3.284 0.132 3.727 0.19v4.319l-2.557 0.001c-2.005 0-2.393 0.953-2.393 2.351v3.083h4.782l-0.623 4.83h-4.16v12.392h8.154c0.975 0 1.766-0.791 1.766-1.766v-28.468c0-0.976-0.791-1.766-1.766-1.766h-28.468z'></path>
      </symbol>
    </svg>
    <div class='spacer-3'></div>
  `;

  static get selectors() {
    return Object.assign({}, super.selectors, {
      ContactUsButton: `[type=submit]`,
      Email: `[name=email]`,
      Message: `[name=message]`,
      MessageBox: `.msg`,
      Name: `[name=name]`,
      Subject: `[name=subject]`,
    });
  }

  static get elements() {
    let s = this.selectors;
    return {
      emailElement: s.Email,
      messageElement: s.Message,
      nameElement: s.Name,
      subjectElement: s.Subject,
    };
  }

  get historyState() {
    return [
      { page: this.page },
      `Contact Us | CamperAid`,
      `${window.location.origin}/contact-us`,
    ];
  }

  switchOn() {
    super.switchOn();
    (profile.name ? this.subjectElement : this.nameElement).focus();
  }

  async contactUs() {
    const name = this.nameElement.value;
    const email = this.emailElement.value;
    const subject = this.subjectElement.value;
    const message = this.messageElement.value;

    log(`[account] contact-us by ${name}<${email}>, subject: ${subject}`);

    this.msgBox.hide();

    let result = await app.contactUs({
      name,
      email,
      subject,
      message,
    });

    result != app.Success
      ? this.msgBox.unexpectedError()
      : this.msgBox.success(`Your message has been successfully sent.`);
  }
}

navigation.registerPanel(ContactUsPanel);

export { ContactUsPanel };
